import GoogleMapsApiLoader from "google-maps-api-loader";

export default GoogleMapsApiLoader({
	apiKey: process.env.VUE_APP_MAP_API
});
